export const UPPER_IDS_NONE: string[] = [];
